import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import {
  required,
  youtubeUrl,
  number,
  minLength1,
  maxLength10,
  mustBeSelected,
  positiveNumber
} from '../../../../_utils/validators';
import {
  getComposersList,
  getPerformersList,
  getFilmsList,
  clearPriceField
} from '../../../actions/shop';
import { ARRANGEMENT_TYPE_SLUG, moderatorMaxTagsAmount } from '../../../../config';
import { renderField } from '../../common/FormsControls.jsx';
import ContentRedactor from '../../common/FormFileds/Redactor/ContentRedactor.jsx';
import TagsField from '../../common/FormFileds/Tags/TagsField.jsx';
import DropzoneField from '../../common/FormFileds/Dropzone/DropzoneField.jsx';
import CreatableSelectAutocomplete from '../../common/FormFileds/SelectAutocomplete/CreatableSelectAutocomplete.jsx';


const validate = values => {
  const errors = {}
  if (!values.composer && !values.performer) {
    errors.composer = gettext('Обязательное поле');
  }
  return errors
}

class ArrangementsForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      priceDisabled: props.initialValues.free
    }
    this.listView = `/${props.lang}/my/moderator/${ARRANGEMENT_TYPE_SLUG}/`;
  }

  componentDidMount() {
    this.props.getComposersList();
    this.props.getPerformersList();
    this.props.getFilmsList();
  }

  render() {
    const { anyTouched, invalid, submitting, handleSubmit, submitSucceeded } = this.props;
    const difficultyOptions = this.props.difficulties.map(i => <option value={ i.value }>{ i.label }</option>);
    const tonalityOptions = this.props.tonalities.map(i => <option value={ i.value }>{ i.label }</option>);

    return <Form onSubmit={ handleSubmit } className={ '' + (anyTouched ? ' was-validate' : '') }>
      <fieldset>
        <legend>{ gettext('Описание:') }</legend>
        <Field component={ renderField }
               element="input"
               required='required'
               name='name'
               validate={ [required] }
               label={ gettext('Название кавера, аранжировки, сочинения') }
               placeholder={ gettext('Название кавера, аранжировки, сочинения') }
               helptext={ gettext('Не пишите в названии "ноты", "миди", "имя композитора"') }/>

        <Field component={ ContentRedactor }
               name='description'
               validate={ [required] }
               required='required'
               label={ gettext('Подробное описание') }
               placeholder={ gettext('Подробное описание') }
               helptext={ gettext('Дополнительный перенос строки делается комбинацией клавиш Shift+Enter') }/>

        <Field component={ TagsField }
               type={ ARRANGEMENT_TYPE_SLUG }
               name='tags'
               required='required'
               validate={ [required, minLength1, maxLength10] }
               max_amount={ moderatorMaxTagsAmount }
               label={ gettext('Теги') }
               placeholder={ gettext('Добавить тег') }
               helptext={ gettext('Выберите 1 - 10 тегов, максимально соответствующие аранжировке.') }/>

        <Field component={ renderField }
               element="input"
               required='required'
               name='video_url'
               validate={ [required, youtubeUrl] }
               label={ gettext('Ссылка на видео-демонстрацию (Youtube)') }
               placeholder={ gettext('Ссылка на видео-демонстрацию (Youtube)') }
               helptext={ gettext('Разрешается добавлять ссылки только на youtube') }/>
      </fieldset>
      <fieldset>
        <legend>{ gettext('Характеристики:') }</legend>
        <Field component={ CreatableSelectAutocomplete }
               options={ this.props.composerOptions }
               element="input"
               required='required'
               name='composer'
               label={ gettext('Композитор') }
               placeholder={ gettext('Выберете композитора или добавьте нового') }
               helptext={ gettext('Если вы не знаете композитора данного произведения, то укажите эстрадного исполнителя') }/>

        <Field component={ CreatableSelectAutocomplete }
               options={ this.props.performerOptions }
               element="input"
               required='required'
               name='performer'
               label={ gettext('Эстрадный исполнитель') }
               placeholder={ gettext('Выберете исполнителя или добавьте нового') }
               helptext={ gettext('Поле является обязательным, если вы не указали композитора данного произведения') }/>

        <Field component={ CreatableSelectAutocomplete }
               options={ this.props.filmOptions }
               element="input"
               name='film'
               label={ gettext('Кинофильм') }
               placeholder={ gettext('Выберете кинофильм или добавьте новый') }
               helptext={ gettext('Укажите кинофильм, в котором звучало данное произведение') }/>

        <Field component={ renderField }
               element="input"
               name='price'
               required='required'
               disabled={ this.state.priceDisabled }
               label={ gettext('Стоимость скачивания файлов') }
               validate={ [number, positiveNumber] }
               withInputGroup={ true }
               inputGroupPrepend={ this.props.currency }
               helptext={ gettext('Укажите стоимость, только цифры.') }/>

        <Field name="difficulty"
               required='required'
               component={ renderField }
               element="select"
               label={ gettext('Сложность') }
               validate={ [required, mustBeSelected] }>
          <option value={0}>{ gettext('---------') }</option>
          { difficultyOptions }
        </Field>

        <Field name="tonality"
               required='required'
               component={ renderField }
               element="select"
               label={ gettext('Тональность') }
               validate={ [required, mustBeSelected] }>
          <option value={0}>{ gettext('---------') }</option>
          { tonalityOptions }
        </Field>

        <p><span className='font-weight-bold'>{ gettext('Загрузите файлы (обязательно):') }</span><br/>
          <span
            className='text-muted small'>{ gettext('Необходим минимум 1 файл - Ноты и Миди в формате PDF.')
          + ' ' + gettext('Из первого добавленного PDF файла будет автоматически сформировано превью нот.')}</span>
        </p>
        { this.props.hideDeleteFileActions &&
        <Alert variant='danger' className='mt-3'>{gettext('Внимание! Товар уже был продан.')}</Alert> }
        <Field component={ DropzoneField }
               name='files'
               existingFiles={ this.props.updatedFiles }
               hideDeleteActions={ this.props.hideDeleteFileActions }
               validate={ [required] }
        />
      </fieldset>
      <fieldset className='mt-3'>
        <legend>{ gettext('Настройки:') }</legend>
          <Field component={ renderField }
                 element='checkbox'
                 name='author_music'
                 componentLabel={ gettext('Авторская музыка') }/>
          <Field component={ renderField }
                 element='checkbox'
                 name='checked'
                 componentLabel={ gettext('Модератором проверено') }
                 helptext={ gettext('Пользовательские варианты (композитор, исполнитель, фильм) будут автоматически приняты') }/>
      </fieldset>
      <fieldset>
        <legend>SEO:</legend>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_title'
               validate={ [required] }
               label={ gettext('Название (Title)') }/>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_metadesc'
               validate={ [required] }
               label={ gettext('Описание (meta description)') }/>
        <Field component={ renderField }
               element="input"
               required='required'
               name='seo_metakeywords'
               validate={ [required] }
               label={ gettext('Ключевые слова, через запятую (meta keywords)') }/>
      </fieldset>


      { (submitting || invalid) &&
      <Alert variant='danger' className='mt-3'>{gettext('Проверьте правильность заполнения формы.')}</Alert> }

      <div className='text-lg-right mt-3'>
        <Link className='btn btn-outline-secondary mr-2 mt-2 mt-md-0' to={ this.listView } >
          <i className='icon icon-pencil'></i> { gettext('Отменить') }
        </Link>
        <Button variant="primary" type="submit" disabled={submitting || invalid}
                className='mt-2 mt-md-0'>{gettext('Сохранить')}</Button>
      </div>
    </Form>
  }
}

let mapStateToProps = (state) => {
  return {
    lang: state.auth.lang,
    currency: state.auth.currency,

    agreeForPromotion: state.auth.agree_for_promotion,
    possibleFreeCount: state.auth.possible_free_arrangement_count,

    initialValues: state.shop.initialValues,
    updatedFiles: state.shop.updatedFiles,
    hideDeleteFileActions: state.shop.hideDeleteFileActions,
    composerOptions: state.shop.composerOptions,
    performerOptions: state.shop.performerOptions,
    filmOptions: state.shop.filmOptions,
    tonalities: state.shop.tonalities,
    difficulties: state.shop.difficulties,
  }
};


export default compose(
  connect(
    mapStateToProps,
    {
      getComposersList, getPerformersList, getFilmsList,
      clearPriceField
    }),
  reduxForm({
    form: 'arrangementForm',
    validate
  })
)(ArrangementsForm);
